// assets
import { IconBuildingBridge, IconBuildingCommunity, IconTractor, IconBucket, IconPlug, IconSchool } from '@tabler/icons-react';

// constant
const icons = {
    IconBuildingBridge,
    IconBuildingCommunity,
    IconTractor,
    IconBucket,
    IconPlug,
    IconSchool
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const shiselweni = {
    id: 'shiselweni',
    title: 'SHISELWENI',
    caption: 'Shiselweni',
    type: 'group',
    children: [
        {
            id: 'dashboard-shiselweni',
            title: 'Dashboard',
            type: 'item',
            url: '/civils/dashboard/shiselweni',
            icon: icons.IconDashboard,
            breadcrumbs: false
        },
        {
            id: 'project-overview',
            title: 'Project Overview',
            type: 'collapse',
            icon: icons.IconBuildingBridge,

            children: [
                {
                    id: 'lowLevelCrossing',
                    title: 'Low Level Crossings',
                    type: 'item',
                    url: '/civils/shiselweni/low-level-crossing',
                    target: false
                },
                {
                    id: 'footbridges',
                    title: 'Foot Bridges',
                    type: 'item',
                    url: '/civils/shiselweni/foot-bridges',
                    target: false
                },
                {
                    id: 'roads',
                    title: 'Roads',
                    type: 'item',
                    url: '/civils/shiselweni/roads',
                    target: false
                },
                {
                    id: 'halls',
                    title: 'Commuinity Halls',
                    type: 'item',
                    url: '/civils/shiselweni/community-halls',
                    target: false
                }
            ]
        }
    ]
};

export default shiselweni;
